import React, { memo } from 'react';
import { motion } from 'framer-motion';
export function HowItWorks() {
  const steps = [{
    number: '1',
    title: 'Identificás',
    description: 'Entendés por qué tu gato está gritando a través de su orina'
  }, {
    number: '2',
    title: 'Eliminás',
    description: 'Borrás la memoria química de tus muebles con limpieza enzimática'
  }, {
    number: '3',
    title: 'Re-configurás',
    description: 'Aplicás el mapa de ubicación y feromonas para sellar el nuevo hábito'
  }];
  return <section className="w-full bg-[#FAFAF7] py-16 md:py-20 px-6" data-id="element-51">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.6
    }} className="max-w-4xl mx-auto" data-id="element-52">
        <h2 className="font-['Playfair_Display'] text-3xl md:text-4xl font-bold text-[#1C1C1C] mb-12 text-center" data-id="element-53">
          Cómo funciona
        </h2>

        <div className="space-y-8" data-id="element-54">
          {steps.map((step, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="flex gap-6 items-start" data-id="element-55">
              <div className="flex-shrink-0 w-16 h-16 bg-[#2D8C5A] rounded-full flex items-center justify-center" data-id="element-56">
                <span className="font-['Playfair_Display'] text-3xl font-bold text-white" data-id="element-57">
                  {step.number}
                </span>
              </div>
              <div className="flex-1 pt-2" data-id="element-58">
                <h3 className="font-['Playfair_Display'] text-2xl font-semibold text-[#1C1C1C] mb-2" data-id="element-59">
                  {step.title}
                </h3>
                <p className="text-lg text-[#1C1C1C]/70 leading-relaxed" data-id="element-60">
                  {step.description}
                </p>
              </div>
            </motion.div>)}
        </div>
      </motion.div>
    </section>;
}